import { Injectable } from '@angular/core';

import { Timestamp, arrayUnion, collection, doc, setDoc, count, sum, average, getAggregateFromServer, getFirestore, deleteDoc, getDocs, where, query, documentId, getDoc, updateDoc, getDocFromCache, addDoc, orderBy, increment } from "firebase/firestore";
import moment from 'moment';
import { BehaviorSubject, Observable, defer, from, switchMap } from 'rxjs';
import { ownedCollection, withCurrentOwner } from '../../../utils/firestore-ownership';


@Injectable({
  providedIn: 'root'
})
export class FixedService {

  private incomes!: BehaviorSubject<any[]>;

  constructor() {
    this.incomes = new BehaviorSubject<any[]>([])
  }

  public async selectAll(): Promise<void> {
    // console.log('FixedService', 'selectAll')

    const incomes:any[] = []

    // const q = query(collection(getFirestore(), "Stocks"), where("side", "==", 'BUY'), orderBy('side', 'asc'))
    const q = ownedCollection('FixedIncomes');
    const allDocs = await getDocs(q)
    allDocs.docs.forEach((d:any, j:any, h:any) => {
      // console.log('Doc:', d.id, j, h)
      const doc = { ...d.data(), id: d.id }
      incomes.push(doc)
    })

    this.incomes.next(incomes)
  }

  getAll(): Observable<any[]> {
    console.log('FixedService', 'getAll')

    return defer(() => from(this.selectAll()).pipe(switchMap(() => this.incomes.asObservable())));
  }
  
  async addItem(e:any):Promise<void> {
    console.log('FixedService', 'addItem', e)

    await addDoc(collection(getFirestore(), 'FixedIncomes'), { ...withCurrentOwner(e), created_on: Timestamp.now(), modified_on: Timestamp.now() });
    // this.incomes.next([e, ...this.incomes.value])
    await this.selectAll()
  }

  async delete(e:any):Promise<void>{
    console.log('FixedService', 'delete', e.id)

    await deleteDoc(doc(getFirestore(), 'FixedIncomes', e.id));
    await this.selectAll();
  }

  async modify(e:any):Promise<void>{
    console.log('FixedService', 'modify', e.id)

    await updateDoc(doc(getFirestore(), 'FixedIncomes', e.id), { ...withCurrentOwner(e), modified_on: Timestamp.now() });
    await this.selectAll();
  }

  async updateAttach(e: any, path: string, name: string) {
    console.log('FixedService', 'updateAttach', e.id)
    
    await updateDoc(doc(getFirestore(), "FixedIncomes", e.id), {
      attach: increment(1),
      attachments: arrayUnion({ path, name, createdOn: Timestamp.now() })
    })
    .then(() => {
      console.log('FixedService', 'updateAttach', e.id, 'UPDATED')
    })
    
  }

}
